import { Services } from '../../types/services';

// Interfaces
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface State {
  // Empty state
}

interface Action {
  type: string;
  payload?: unknown;
}

const initialState: State = {
  // Empty state
};

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;
  }
};

export const actions = (_services: Services) => {
  // No functions are used externally
  return {};
};
